"use client";

import { c as _c } from "react/compiler-runtime";
import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Plus, Minus } from "lucide-react";
const faqs = [{
  question: "Who were the Girmitiyas?",
  answer: "Girmitiyas were Indian indentured labourers who were transported to various British, Dutch, and French colonies between 1838 and 1917. They traveled under a contract or 'girmit' to work primarily on sugar plantations, laying the foundation for a vast global diaspora."
}, {
  question: "What is the primary mission of the Council?",
  answer: "The Global Girmitiya Council is dedicated to preserving, documenting, and celebrating the shared cultural heritage of the Girmitiya diaspora. We aim to build a comprehensive digital archive of historical documents, oral histories, and migration records."
}, {
  question: "How can I contribute to the digital archive?",
  answer: "We warmly welcome submissions from descendants, researchers, and cultural institutions. If you possess original photographs, ship manifests, or personal correspondence, please use our Contact page to initiate an archive submission."
}, {
  question: "Which nations are part of the Girmitiya diaspora?",
  answer: "The diaspora spans across the globe, with major historical populations in Mauritius, Fiji, South Africa, Trinidad and Tobago, Guyana, Suriname, and Jamaica, as well as subsequent migrations to North America, the UK, and Australasia."
}, {
  question: "Do you offer resources for genealogical research?",
  answer: "Yes, one of our primary goals is to digitize and organize colonial-era ship passenger manifests and plantation records to assist descendants in tracing their ancestral roots back to the Indian subcontinent."
}];
const FAQ = () => {
  const $ = _c(7);
  const [openIndex, setOpenIndex] = useState(0);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="absolute inset-0 pointer-events-none opacity-[0.02]" style={{
      backgroundImage: "url(\"data:image/svg+xml,%3Csvg viewBox='0 0 256 256' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='noise'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='4' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23noise)'/%3E%3C/svg%3E\")"
    }} />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="flex items-center gap-2 sm:gap-3 mb-4 sm:mb-6"><div className="w-8 h-px bg-[#DF6D2A]" /><span className="font-body text-[10.5px] tracking-[0.25em] uppercase text-[#DF6D2A] font-light">Common Inquiries</span><div className="w-8 h-px bg-[#DF6D2A]" /></div>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="text-center mb-10 sm:mb-16 md:mb-24 flex flex-col items-center">{t1}<h2 className="font-display text-[34px] sm:text-[44px] md:text-[56px] font-light leading-[1.05] tracking-[-0.02em] text-[#0F1C2E]">Frequently Asked <em className="text-[#C9A84C] italic">Questions</em></h2></div>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== openIndex) {
    t3 = faqs.map((faq, index) => {
      const isOpen = openIndex === index;
      return <div key={index} className="border-b border-[#0F1C2E]/15"><button onClick={() => setOpenIndex(isOpen ? null : index)} className="w-full flex items-center justify-between py-5 sm:py-6 md:py-8 text-left group"><h3 className={`font-display text-[20px] sm:text-[24px] md:text-[32px] font-light tracking-tight transition-colors duration-300 pr-4 ${isOpen ? "text-[#DF6D2A]" : "text-[#0F1C2E] group-hover:text-[#DF6D2A]"}`}>{faq.question}</h3><div className={`ml-3 sm:ml-6 w-8 h-8 sm:w-10 sm:h-10 rounded-full border flex-shrink-0 flex items-center justify-center transition-colors duration-300 ${isOpen ? "border-accent-cta bg-accent-cta text-white" : "border-[#0F1C2E]/20 text-[#0F1C2E] group-hover:border-accent-cta group-hover:text-accent-cta"}`}>{isOpen ? <Minus size={16} strokeWidth={1.5} /> : <Plus size={16} strokeWidth={1.5} />}</div></button><AnimatePresence>{isOpen && <motion.div initial={{
            height: 0,
            opacity: 0
          }} animate={{
            height: "auto",
            opacity: 1
          }} exit={{
            height: 0,
            opacity: 0
          }} transition={{
            duration: 0.4,
            ease: "easeOut"
          }} className="overflow-hidden"><p className="font-body text-[14px] sm:text-[16px] md:text-[17px] font-light text-[#4C596B] leading-[1.7] sm:leading-[1.8] pb-6 sm:pb-10 max-w-[850px] pr-4 sm:pr-8">{faq.answer}</p></motion.div>}</AnimatePresence></div>;
    });
    $[3] = openIndex;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t3) {
    t4 = <section className="bg-[#F4EFE6] py-16 sm:py-24 md:py-32 relative border-t border-[#0F1C2E]/10">{t0}<div className="max-w-[1000px] mx-auto px-4 sm:px-6 md:px-8 relative z-10">{t2}<div className="flex flex-col border-t border-[#0F1C2E]/15">{t3}</div></div></section>;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  return t4;
};
export default FAQ;